export enum BulletPointStyle {
    Checkmark = 'Checkmark',
    Arrow = 'Arrow',
    ExclamationPoint = 'ExclamationPoint',
    Cloud = 'Cloud',
    QuestionMark = 'QuestionMark',
    Star = 'Star',
    Number = 'Number',
}
